import React, { Component } from 'react';
import '../App.css';

import Grid from '@material-ui/core/Grid';

import Header from '../components/Header';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import { IconButton } from '@material-ui/core';

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import EditIcon from '@material-ui/icons/Edit';
import FaceIcon from '@material-ui/icons/Face';
import VisibilityIcon from '@material-ui/icons/Visibility';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Cookies from 'universal-cookie';
import GetAppIcon from '@material-ui/icons/GetApp';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import axios from 'axios';
import { i18n } from '../components/i18n';
import LocalizedStrings from 'react-localization';

import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

const strings = new LocalizedStrings(i18n);

const API = 'https://api.sivan-school.com/v1/';
const cookies = new Cookies();
const UID = '5fc0e4385f2d973c46a8e220';

class NewSivanBoardMessage extends Component {
  componentDidMount () {
    this.getMessage();
    this.getCategories();

    if (cookies.get('language') === "hebrew") {
      this.setState({language: 'he'});
      strings.setLanguage('he');
    } else if (cookies.get('language') === "arabic") {
      this.setState({language: 'ar'});
      strings.setLanguage('ar');
    } else if (cookies.get('language') === "english") {
      this.setState({language: 'en'});
      strings.setLanguage('en');
    } else if (cookies.get('language') === "russian") {
      this.setState({language: 'ru'});
      strings.setLanguage('ru');
    } else {
      this.setState({language: 'he'});
      strings.setLanguage('he');
    }
  }

  constructor(props) {
   super(props);
   this.state = {
     messages: [],
     lastSeen: '',
     language: 'he',

     isLastMinute: false,
     lastMinuteMaxDate: new Date(Date.now()),
     price: 0,
     priceWanted: 0,
     phoneNumber: '',
     freetext: '',
     file: null,
     categories: [],
     messageId: '',
     message: {},
   }
  }


  onChange = (e) => {
      this.setState({file:e.target.files[0]});
  }

  getMessage = async () => {
    let name = 'id';
    let url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    this.setState({messageId: decodeURIComponent(results[2].replace(/\+/g, ' '))}, () => {
      axios.get(API + 'stores/sivanboardmessage?id='+this.state.messageId+'&storeId='+UID, {
        headers: { Authorization: `Bearer ${cookies.get('token___school')}` }
      })
      .then(response => {
        console.log(response);
        if (response.data.status === "ok") {
          this.setState({
            isLastMinute: response.data.data.sivanboardmessage.isLastMinute,
            lastMinuteMaxDate: response.data.data.sivanboardmessage.lastMinuteMaxDate,
            freetext: response.data.data.sivanboardmessage.freetext,
            price: response.data.data.sivanboardmessage.price,
            phoneNumber: response.data.data.sivanboardmessage.phoneNumber,
          });
        } else {
          // alert(strings.errorPleaseTryAgain);
        }
      })
      .catch(error => {
        console.log(error);
        alert(strings.errorPleaseTryAgain);
      });
    })
  }

  handleIsLastMinute = () => {
    let value = this.state.isLastMinute;
    if (value) {
      this.setState({isLastMinute: false});
    } else {
      this.setState({isLastMinute: true});
    }
  }


  getCategories = async () => {
    axios.get(API + 'stores/guest/s-categories?id='+UID, {
      headers: { Authorization: `Bearer ${cookies.get('token___school')}` }
    }).then(response => {
        console.log(response);
        if (response.data.status === "ok") {
          this.setState({
            categories: response.data.data.categories
          });
        } else {
          // alert(strings.errorPleaseTryAgain);
        }
      })
      .catch(error => {
        console.log(error);
        alert(strings.errorPleaseTryAgain);
      });
    }

  onFormSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('file',this.state.file);
    formData.append('isLastMinute',this.state.isLastMinute);
    formData.append('lastMinuteMaxDate',this.state.lastMinuteMaxDate);
    formData.append('price',this.state.price);
    formData.append('priceWanted',this.state.priceWanted);
    formData.append('phoneNumber',this.state.phoneNumber);
    formData.append('freetext',this.state.freetext);
    formData.append('category',this.state.category);
    formData.append('storeId',this.state.UID);

    const config = {
        headers: {
            'content-type': 'multipart/form-data',
            Authorization: `Bearer ${cookies.get('token___school')}`
        }
    };
    axios.put(API + 'stores/sivanboardmessage?id='+this.state.messageId+'&storeId='+UID,formData,config)
    .then((response) => {
      alert('המודעה שלך נשלחה ומחכה לאישור המערכת. תודה!');
      window.location.href='/board';
    }).catch((error) => {
      console.log(error);
    });

  }

  fileSizeLimit = () => {
    if (this.state.file !== null) {
      let size = this.state.file.size;

      let sizeMB = (size / 1000000);

      const limit = 2;

      if (sizeMB > limit) return false;
      else return true;
    } else {
      return false;
    }
  }


  render() {
    return (
      <div className="App">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Header type={'logged'} lastSeen={this.state.lastSeen}/>
          </Grid>
          <Grid item xs={12}>
            <center>
              <div style={{maxWidth: '90%'}}>
                <h2 style={{textAlign: 'right'}}>{strings.newmessageboardsivan}</h2>
              </div>
            </center>
          </Grid>

          <Grid item xs={12}>
              <form onSubmit={this.onFormSubmit}>
                <br />
                <div style={{textAlign: 'right', direction: 'rtl', marginRight: '5%'}}>
                  <Checkbox
                    checked={this.state.isLastMinute}
                    onChange={(e) => this.handleIsLastMinute()}
                  /> האם מוצר בעל תוקף?
                </div>

                {this.state.isLastMinute && (
                  <React.Fragment>
                    <p style={{textAlign: 'right', direction: 'rtl', marginRight: '5%'}}>{strings.productexp}:</p>
                    <TextField
                      value={this.state.lastMinuteMaxDate}
                      onChange={(e) => this.setState({lastMinuteMaxDate: e.target.value})}
                      type='date'
                      style={{
                        textAlign: 'right',
                        direction: 'rtl',
                        width: '90%'
                      }}
                    />
                  </React.Fragment>
                )}

                <center>
                <p style={{textAlign: 'right', direction: 'rtl', marginRight: '5%'}}>{strings.category}:</p>
                <Select
                  value={this.state.category}
                  onChange={(e) => this.setState({category: e.target.value})}
                  style={{
                    width:'90%',
                    textAlign:'right',
                    direction:'rtl'
                  }}
                >
                  {this.state.categories.map((index) => {
                    return (
                      <MenuItem style={{
                        textAlign:'right',
                        direction:'rtl'
                      }} value={index.name}>{index.name}</MenuItem>
                    )
                  })}
                </Select>
                </center>

                <p style={{textAlign: 'right', direction: 'rtl', marginRight: '5%'}}>{strings.buycost}:</p>
                <TextField
                  value={this.state.price}
                  onChange={(e) => this.setState({price: e.target.value})}
                  type='number'
                  style={{
                    textAlign: 'right',
                    direction: 'rtl',
                    width: '90%'
                  }}
                />

                <p style={{textAlign: 'right', direction: 'rtl', marginRight: '5%'}}>{strings.wantedprice}:</p>
                <TextField
                  value={this.state.priceWanted}
                  onChange={(e) => this.setState({priceWanted: e.target.value})}
                  type='number'
                  style={{
                    textAlign: 'right',
                    direction: 'rtl',
                    width: '90%'
                  }}
                />

                <p style={{textAlign: 'right', direction: 'rtl', marginRight: '5%'}}>{strings.phonenumber}:</p>
                <TextField
                  value={this.state.phoneNumber}
                  onChange={(e) => this.setState({phoneNumber: e.target.value})}
                  style={{
                    textAlign: 'right',
                    direction: 'rtl',
                    width: '90%'
                  }}
                />

                <p style={{textAlign: 'right', direction: 'rtl', marginRight: '5%'}}>{strings.freetext}:</p>
                <textarea
                  value={this.state.freetext}
                  onChange={(e) => this.setState({freetext: e.target.value})}
                  style={{
                    textAlign: 'right',
                    direction: 'rtl',
                    width: '90%'
                  }}
                  rows={5}
                ></textarea>
                <br />
                <div style={{textAlign: 'right'}}>
                <br />
                <div class="upload-btn-wrapper" style={{marginRight: '5%'}}>
                  <label for="file-upload" class="custom-file-upload">
                      <i class="fa fa-cloud-upload"></i> {strings.chooseproductimages}
                  </label>
                  <input type="file" id="file-upload" name="myImage" onChange={this.onChange} accept="image/*"/>
                </div>

                {(this.state.file !== undefined && this.state.file !== null && this.state.file !== '') && (
                  <React.Fragment>
                  <p style={{color: 'black', fontSize: '1em', direction: 'rtl', marginRight: '5%'}}>{strings.filechosen}: {this.state.file.name}</p>
                  </React.Fragment>
                )}

                <center><Button type="submit" variant={'contained'} color={'primary'}>{strings.uploadtoboard}</Button></center>
                </div>
              </form>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default NewSivanBoardMessage;
